import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  ButtonGroup: {
    marginRight: 30,
  },
  ExpandMoreIcon: {
    "&.MuiSvgIcon-root": {
      color: theme.color.white,
    },
  },
  expandButton: {
    borderLeft: "none",
    boxShadow: "none",
    padding: "6px !important",
    minHeight: "37px !important",
  },
  newButton: {
    borderRight: "none",
    boxShadow: "none",
    padding: "6px !important",
  },
  menuButton: {
    marginRight: ` ${theme.spacing(5)}px !important `,
  },
  BtnOnPopper: {
    "&.MuiButtonGroup-grouped": {
      padding: 6,
      justifyContent: "flex-start",
      minWidth: 166,
      background: theme.color.white,
      color: theme.color.black,
      "&:hover": {
        background: "#d5d5d5",
      },
    },
  },
  BtnExpand: {
    "&.MuiButtonGroup-grouped": {
      paddingLeft: 30,
    },
  },
  BtnExport: {
    marginLeft: 20,
  },
  ProjectsPage_Popin: {
    "& .MuiDrawer-paper": {
      width: "786px !important",
      overflowY: "unset !important",
    },
  },
  ProjectsPage_Info: {
    display: "flex",
    alignItems: "center",
    "& h3:not(:first-child)": {
      marginLeft: "10px",
    },
    "&.bordered": {
      borderTop: "1px solid #d8dadc",
    },
  },
}));
